/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { MediaLocation } from '@msdyn365-commerce/retail-proxy';
import { LogLevel, StaticTelemetry } from '@msdyn365-commerce/telemetry-internal';
import axios, { AxiosResponse } from 'axios';

export const getOmniChannelMediaInfoAsync = async (requestContext: IRequestContext, productId: number): Promise<MediaLocation[]> => {
    let cmsEndpoint = requestContext.apiSettings.CMSImagepreviewEndPoint;

    if (!cmsEndpoint) {
        return [];
    }

    cmsEndpoint = cmsEndpoint.replace('{ounid}', requestContext.apiSettings.oun);
    cmsEndpoint = cmsEndpoint.replace('{productid}', `${productId}`);

    let response: AxiosResponse;

    try {
        response = await axios.get(cmsEndpoint, {
            headers: {
                Authorization: `Bearer ${requestContext.user.c1AccessToken}`
            }
        });
    } catch (err) {
        StaticTelemetry.log(LogLevel.Error, `Could not fetch omni channel media info.`, { exception: err });
        return [];
    }

    if (response && response.data && response.status === 200) {
        return response.data as MediaLocation[];
    } else {
        StaticTelemetry.log(LogLevel.Error, `Error reading omni channel media info response`, {
            exception: new Error(`response status: ${response?.status}`)
        });
    }

    return [];
};
